import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { GridSortDirection, GridSortModel } from '@mui/x-data-grid-premium';
import { isEmpty, forEach } from 'lodash';

export const useMatchingEngineGridState = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const sortParams = searchParams.getAll('sort');
  const initialSort = useMemo<GridSortModel>(
    () =>
      sortParams.map((sortItem) => {
        const [field, sort = 'asc'] = sortItem.split(',');
        return { field, sort: sort as GridSortDirection };
      }),
    [sortParams],
  );

  // Using useCallback and memoizing to avoid unneccessary re-renders.
  // https://mui.com/x/react-data-grid/performance/#extract-static-objects-and-memoize-root-props
  const handleSortModelChange = useCallback(
    (sortModel: GridSortModel) => {
      searchParams.delete('sort');

      if (!isEmpty(sortModel)) {
        forEach(sortModel, ({ field, sort }) => {
          searchParams.append('sort', `${field},${sort}`);
        });
      }

      setSearchParams(searchParams);
    },
    [searchParams, setSearchParams],
  );

  const initialState = useMemo(() => {
    return {
      sorting: {
        sortModel: initialSort,
      },
    };
  }, [initialSort]);

  return {
    initialState,
    handleSortModelChange,
  };
};
